<template>
    <div>
        <div class="option-title" v-if="!showPlaneMode">Painel e Loja</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Painel e Loja</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p class="option-subtitle">Eu pago alguma coisa pra criar a minha loja?</p>
                <p>
                    Não, nadica de nada! Não cobramos nenhum tipo de mensalidade ou taxa para a
                    criação da loja.
                </p>
                <p>
                    Nossa precificação parte de um <strong>preço base</strong> e tem uma quantia
                    obrigatória (determinada pelo usuário, mas com valor mínimo de R$1), que é
                    direcionada para algum projeto de impacto socioambiental, cobrado após a venda
                    do produto. Fora isso, você não paga nada para utilizar a plataforma.
                </p>
            </li>

            <li>
                <p class="option-subtitle">O que é possível fazer no painel de Uma Penca?</p>
                <p>
                    Em nosso painel você pode ver e editar sua a loja e todas as informações
                    relacionadas aos seus produtos (exceto a arte da estampa já aprovada), além de
                    seus dados pessoais. Você também pode consultar os pedidos feitos em sua loja,
                    solicitar saque e editar dados bancários, caso necessário. Assim como o
                    relatório de vendas:
                    <strong>tudo atualizado diariamente</strong>. Para acessar o painel, basta
                    <a href="https://umapenca.com/painel/home" class="option-link" target="_blank"
                        >clicar aqui</a
                    >
                    e fazer login com os seus dados.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Como fica o domínio da minha loja?</p>
                <p>
                    Ao realizar o seu cadastro em Uma Penca, sua loja será criada automaticamente
                    com um domínio
                    <strong>umapenca.com/nomedaloja</strong>.
                </p>
                <p>
                    <strong>
                        Atenção: lembramos que ao criar a sua loja, não é permitido a mudança de
                        nome posteriormente.
                    </strong>
                </p>
            </li>

            <li>
                <p class="option-subtitle">Tenho acesso aos dados de quem comprou na minha loja?</p>
                <p>
                    Você poderá ter acesso a alguns dados dos compradores no intuito de facilitar o
                    processo de compra e para melhorar a experiência do comprador.
                </p>
                <p>
                    Assim que você cadastra sua loja na Uma Penca, você deve saber que atuará como
                    "Responsáveis pelo Tratamento" dos Dados Pessoais recebidos, relacionados aos
                    Dados Pessoais do Comprador e como "Encarregados pelo Tratamento" das
                    informações relacionadas aos compradores.
                </p>
                <p>
                    Dessa forma, você deverá cumprir a Lei Geral de Proteção de Dados Pessoais e
                    privacidade aplicáveis e suas políticas de privacidade deverão cumprir os
                    padrões jurídicos aplicáveis.
                </p>
                <p>
                    Você concorda também que os Dados Pessoais compartilhados serão processados
                    conforme indicado neste documento; além disso, essas informações serão tratadas
                    conforme as necessidades e de acordo com os objetivos.
                </p>
                <p>
                    O Lojista deverá proteger os Dados Pessoais contra qualquer processamento,
                    perda, uso, divulgação, aquisição ou acesso não autorizados e notificará aos
                    Compradores e à autoridade competente qualquer acesso ou uso não autorizado
                    dessas informações, conforme exigido pela legislação aplicável.
                </p>
                <p>
                    O Parceiro deve se abster de comunicar, divulgar, transferir ou ceder os Dados
                    Pessoais a terceiros, exceto mediante consentimento prévio, expresso e por
                    escrito dos titulares dos dados.
                </p>
                <p>
                    Se o você desempenhar alguma atividade de tratamento que não esteja relacionada
                    a estes Termos, essa atividade será executada fora do contexto das condições
                    definidas pela Uma Penca. Nesse caso, você será totalmente responsável por esse
                    tratamento, ficando a Uma Penca isenta de qualquer obrigação, ou
                    responsabilidade resultantes.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Qualquer pessoa pode se cadastrar? Preciso de CNPJ?</p>
                <p>
                    Qualquer pessoa a partir dos 18 anos pode criar a sua loja em Uma Penca. O CNPJ
                    não é obrigatório, é possível se cadastrar como pessoa física (CPF) ou jurídica,
                    e o procedimento é o mesmo.
                </p>
                <p>
                    <i
                        >Caso você seja menor de idade, é necessário que um responsável realize o
                        cadastro com todas as informações solicitadas</i
                    >
                </p>
            </li>

            <li>
                <p class="option-subtitle">
                    Como evitar que minha loja seja automaticamente desativada?
                </p>
                <p>
                    As lojas cadastradas em Uma Penca podem ser ativadas e desativadas pelos
                    próprios usuários a qualquer momento. Entretanto, aquelas que se enquadrarem em
                    uma das características abaixo serão automaticamente desativadas pela
                    plataforma:
                </p>
                <ul>
                    <li>Lojas que não apresentem atividade de login por até 90 dias (3 meses)</li>
                    <li>
                        Lojas que não tenham movimentação de venda nos últimos 150 dias (5 meses)
                    </li>
                </ul>
                <p>
                    O lojista receberá um aviso em seu e-mail de cadastro 30 dias antes da conclusão
                    dos prazos descritos acima, permitindo que ele realize um novo login, e/ou uma
                    nova venda.
                </p>
            </li>

            <li>
                <p class="option-subtitle">
                    Minha loja foi desativada por falta de login e/ou venda. Consigo reativá-la?
                </p>
                <p>
                    Para reativar seu cadastro após o vencimento dos prazos descritos no tópico
                    anterior, basta fazer o login normalmente e clicar em “ativar loja”. Em seguida,
                    reative os produtos que desejar. Caso a sua conta esteja inativa por falta de
                    vendas, é necessário que algum pedido seja realizado até o próximo dia útil.
                    Caso contrário, ela será novamente desativada.
                </p>
            </li>

            <li>
                <p class="option-subtitle">O que fazer em caso de congelamento de loja?</p>
                <p>
                    Caso sua loja passe mais de 60 dias desativada, ela será automaticamente
                    congelada. Isso significa que seu acesso ao painel da loja será limitado à seção
                    "Financeiro" onde você poderá verificar seus ganhos e solicitar saques.
                </p>
                <p>
                    Para descongelar sua loja, realize a solicitação diretamente
                    <a href="https://umapenca.com/painel/home" class="option-link" target="_blank"
                        >pelo seu painel</a
                    >, clicando no botão "Descongelar Loja".
                </p>
            </li>

            <li>
                <p class="option-subtitle">Política de Suspensão de Lojas</p>
                <p>
                    Uma Penca adota mecanismos técnicos, administrativos e operacionais voltados à
                    identificação, prevenção e repressão de práticas fraudulentas praticadas por
                    usuários, lojistas ou terceiros que utilizem, direta ou indiretamente, a
                    infraestrutura da plataforma para fins ilícitos ou em desconformidade com os
                    Termos de Uso.
                </p>
                <p>
                    Sempre que forem identificados indícios de fraude ou comportamento atípico que
                    represente risco aos usuários, aos lojistas, aos parceiros financeiros ou à
                    própria integridade da plataforma, a Uma Penca poderá utilizar mecanismos
                    automatizados ou manuais de análise de risco para identificar comportamentos
                    suspeitos.
                </p>
                <p>
                    Verificada a suspeição de fraude ou comportamento atípico, a Uma Penca poderá, a
                    seu exclusivo critério e sem necessidade de notificação prévia:
                </p>
                <ul>
                    <li>
                        Suspender provisoriamente a loja ou o usuário, impedindo novos pedidos e
                        criação de lojas;
                    </li>
                    <li>
                        Reter, temporariamente, os valores oriundos das vendas até a conclusão da
                        análise de risco, podendo repassá-los somente após verificação da
                        legitimidade da transação;
                    </li>
                    <li>
                        Desativar a loja ou a conta de usuário de forma definitiva, em caso de
                        confirmação de fraude ou risco iminente de prejuízo à plataforma ou a
                        terceiros;
                    </li>
                    <li>
                        Invalidar o cadastro do consumidor final que relatar não ter realizado a
                        compra, com exclusão do e-mail da base de envio, impedindo novas
                        comunicações da plataforma.
                    </li>
                </ul>
            </li>
            <li>
                <ol>
                    <li>
                        <p class="option-subtitle">Responsabilidade do Lojista e do Usuário</p>
                        <p>
                            É de inteira responsabilidade do lojista garantir que os dados
                            utilizados para acesso, cadastro e recebimento de valores na plataforma
                            correspondam a informações legítimas e autorizadas. A Uma Penca não se
                            responsabiliza por fraudes cometidas por terceiros com uso de dados
                            verdadeiros obtidos ilicitamente fora da plataforma.
                        </p>
                        <p>
                            O lojista será integralmente responsável por prejuízos decorrentes de
                            estornos de pagamentos (chargebacks), quando verificada a utilização
                            indevida de dados de terceiros em pedidos realizados por meio de sua
                            loja virtual, autorizando expressamente a retenção e compensação dos
                            valores eventualmente devidos pela plataforma.
                        </p>
                    </li>
                    <li>
                        <p class="option-subtitle">Penalidades e Exclusão de Cadastro de Lojas</p>
                        <p>
                            A Uma Penca poderá, a qualquer tempo e mediante critérios objetivos,
                            impedir novo cadastro ou operação de loja vinculada a CPF ou CNPJ
                            previamente associado a práticas fraudulentas, inclusive por meio da
                            reutilização de dados bancários, endereços IP, dados de navegação ou
                            históricos operacionais.
                        </p>
                        <p>
                            Eventual suspensão ou desativação de conta ou loja por motivo de
                            segurança ou suspeita de fraude não gerará direito a indenização,
                            compensação ou ressarcimento de valores referentes a comissões ou
                            transações canceladas, sendo resguardado à Uma Penca o direito de reter
                            valores em caso de potencial risco ou investigação em andamento.
                        </p>
                    </li>
                    <li>
                        <p class="option-subtitle">Cooperação com Autoridades e Terceiros</p>
                        <p>
                            A Uma Penca poderá compartilhar, nos limites da Lei Geral de Proteção de
                            Dados (Lei nº 13.709/2018), informações relevantes com operadoras de
                            cartão, intermediadores financeiros, instituições bancárias e
                            autoridades competentes, para fins de apuração de eventuais crimes,
                            fraudes e responsabilidades civis e criminais.
                        </p>
                        <p>
                            Em casos de suspeita de atividade fraudulenta na plataforma, entre em
                            contato com a equipe de Uma Penca através do e-mail
                            <a href="mailto:dpo@umapenca.com.br" class="text-underline option-link"
                                >dpo@umapenca.com.br</a
                            >. Todas as denúncias serão tratadas com confidencialidade e
                            investigadas com rigor.
                        </p>
                    </li>
                </ol>
            </li>
            <li>
                <p class="option-subtitle">
                    Preciso alterar o CPF/CNPJ cadastrado na minha loja, e agora?
                </p>
                <p>
                    Para realizar a mudança do CPF/CNPJ e nome/razão social da sua loja, entre em
                    contato com o time de atendimento de Uma Penca e informe os novos dados. A loja
                    ficará temporariamente desativada, até que todas as alterações necessárias sejam
                    concluídas. Após a atualização dos dados cadastrais, você deverá reativar sua
                    loja.
                </p>
                <p><strong>Transferência de valores:</strong></p>
                <p>
                    Feita a alteração dos dados cadastrais da loja, os dados bancários também serão
                    atualizados na plataforma de meio de pagamentos. Após uma solicitação formal à
                    plataforma, o valor disponível para saque na sua conta atual será transferido
                    para a nova conta cadastrada em até 90 dias. Durante esse período, o valor não
                    será exibido no seu painel de vendas em Uma Penca, mas não se preocupe, ele será
                    transferido integralmente dentro do prazo informado. Recomendamos que você
                    realize o saque do saldo total disponível antes mesmo de solicitar a alteração
                    dos dados da loja. Assim, você evita a espera pela transferência.
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PainelTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
